module.exports = __webpack_public_path__ + "static/media/menu.ca394ec8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menu.svg
// module id = 150
// module chunks = 0